<template>
  <div class="data-table">
    <div class="table-cell" :class="{main: props.isMain}">
      <div class="heading">Scripts</div>
      <div class="value">{{ scripts.toFixed(0) }}</div>
    </div>
    <div class="table-cell">
      <div class="heading">vs PQ</div>
      <div class="value" :class="changeClass(scriptsVersusPreviousQuarter)">
        <span v-if="scriptsVersusPreviousQuarter > 0" class="triangle-up"></span>
        <span v-else-if="scriptsVersusPreviousQuarter < 0" class="triangle-down"></span>
        <span >
          {{ formatPercent(scriptsVersusPreviousQuarter,1) }}
        </span>
      </div>
    </div>
    <div class="table-cell" :class="{main: props.isMain}">
      <div class="heading">Claims</div>
      <div class="value">{{ claims.toFixed(0) }}</div>
    </div>
    <div class="table-cell">
      <div class="heading">vs PQ</div>
      <div class="value" :class="changeClass(claimsVersusPreviousQuarter)">
        <span v-if="claimsVersusPreviousQuarter > 0" class="triangle-up"></span>
        <span v-else-if="claimsVersusPreviousQuarter < 0" class="triangle-down"></span>
        <span >
          {{ formatPercent(claimsVersusPreviousQuarter,1) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatPercent } from '@/components/common/common';

interface IProps {
  scripts: number
  scriptsVersusPreviousQuarter: number
  claims: number
  claimsVersusPreviousQuarter: number
  isMain?: boolean
}

const props = defineProps<IProps>()

const changeClass = (change: number) => {
  return change > 0 ? 'positive' : change < 0 ? 'negative' : '';
};
</script>

<style scoped>
.data-table {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
}

.table-cell {
  padding: 0.3125rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-cell:nth-child(1),
.table-cell:nth-child(3) {
  border-right: 0.09375rem solid var(--color-text-90);
}

.table-cell.main:nth-child(1),
.table-cell.main:nth-child(3) {
  border-right: 0.09375rem solid var(--color-background-bright-90);
}

.heading {
  font-size: var(--font-size-small);
}

.value {
  display: flex;
  align-items: center;
  font-size: var(--font-title-3);
  font-weight: 500;
  margin-top: 0.3125rem;
  gap: 0.3125rem;
}

.triangle-up,
.triangle-down {
  width: 0;
  height: 0;
  border-left: 0.3125rem solid transparent;
  border-right: 0.3125rem solid transparent;
}

.triangle-up {
  border-bottom: 0.625rem solid;
}

.triangle-down {
  border-top: 0.625rem solid;
}

.positive {
  color: #2CD599;
}

.negative {
  color: rgb(236, 88, 88);
}
</style>
